import * as React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Card, Typography, CardMedia, Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function PhotoReviewCard({ photo, onClick }) {
  const styles = {
    card: {
      display: 'block',
      flexDirection: 'row',
      alignSelf: 'left',
      p: 2,
      border: '1px solid #E0E0E0',
    },
    image: {
      py: 1,
      objectFit: 'contain',
      cursor: 'pointer',
    },
  };

  return (
    <Card sx={{ ...styles.card }}>
      <Typography sx={{ my: 5, fontSize: '14px' }} variant="subtitle">
        <span style={{ fontWeight: 'bold' }}>
          {photo.username || 'Unknown'} ({photo.walmart_id || 'N/A'})
        </span>{' '}
        from{' '}
        <span style={{ fontWeight: 'bold' }}>Store {photo.store_number}</span>
      </Typography>

      <Typography sx={{ pb: 1, mt: 1, fontSize: '12px' }} variant="subtitle2">
        {moment
          .tz(photo.updated_at, 'America/Chicago')
          .format('MMMM Do, YYYY [at] h:mmA z')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          mb: 0,
          pb: 0,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 'bold', fontSize: '14px' }}
        >
          {photo.department_description}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1, fontSize: '14px' }}>
          {photo.area_title}
        </Typography>
      </Box>
      <CardMedia
        component="img"
        height="300"
        image={photo.photo_url}
        alt={`Store ${photo.store_number}`}
        sx={styles.image}
        onClick={onClick}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'start',
          alignItems: 'baseline',
          mt: 1,
        }}
      >
        <Typography sx={{ mt: 0, mr: 1, fontSize: '12px' }} variant="subtitle2">
          {photo.requirement_title}
          {` `}
        </Typography>
        <Tooltip
          style={{ alignSelf: 'center' }}
          title={photo.requirement_description}
        >
          <InfoOutlinedIcon
            sx={{ width: '15px', height: '15px', color: '#5C6A7D' }}
          />
        </Tooltip>
      </Box>
    </Card>
  );
}

PhotoReviewCard.propTypes = {
  photo: PropTypes.shape({
    photo_url: PropTypes.string.isRequired,
    store_number: PropTypes.string,
    department_title: PropTypes.string,
    department_description: PropTypes.string,
    requirement_title: PropTypes.string,
    requirement_description: PropTypes.string,
    area_title: PropTypes.string,
    username: PropTypes.string,
    walmart_id: PropTypes.string,
    updated_at: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};
